<a [routerLink]="'/'" class="promotion-item" *ngIf="promotionContent && promotionContent.promotionImage">
  <img [src]="promotionContent.promotionImage.thumbnailBlobStorageUrl" />
  <div class="p-3 pb-2 d-flex flex-column justify-content-between box-text" *ngIf="promotionContent?.title">
    <span class="type" [innerHTML]="(promotion?.isPcsd ? pcsdText : promotion?.isIsg ? 'ISG' : '') | translate"></span>
    <h4 [innerHtml]="promotionContent.title" [ngClass]="hasLargeTitle ? 'large-title' : ''"></h4>
  </div>
</a>
